import { ComponentData } from "@companion-core/shared/app/Interfaces/API";

const dynamicComponentPrefixes: Record<string, string> = {
  offer: "OFF",
  event: "EVE",
  editorial: "EDI",
  card: "CAR",
  vendor: "VEN",
};

/**
 * Retrieves the tracking friendly component ID based on the provided component data.
 *
 * @param {ComponentData} component - The component data object.
 * @return {string} The tracking friendly component ID.
 */
export const getDynamicComponentId = (component: ComponentData): string => {
  const componentId = component?.parent_id;
  const componentPrefix = component?.content_ct
    ? dynamicComponentPrefixes[component.content_ct]
    : "";
  return componentId ? componentPrefix + componentId : "";
};

/**
 * Retrieves the dynamic component vendor ID based on the provided component data.
 *
 * @param {ComponentData} component - The component data object.
 * @returns {string} The dynamic component vendor ID, prefixed with 'VEN' if it exists, otherwise an empty string.
 */
export function getDynamicComponentVendorId(component: ComponentData): string {
  const vendor = component && "vendor" in component ? component.vendor : undefined;
  const vendorId = vendor?.id;
  return vendorId ? `VEN${vendorId}` : "";
}
